
(function($){

	$(document).ready(function() {

		$(document).on('click', 'a[href^="#"]', function (e) {

				e.preventDefault(); // prevent hard jump, the default behavior

				var target = $(this).attr("href"); // Set the target as variable

				if( $(target).length  < 1 ){
					return;
				}

				// perform animated scrolling by getting top-position of target-element and set it as scroll target
				$('html, body').stop().animate({
						scrollTop: $(target).offset().top
				}, 600, function() {
						location.hash = target; //attach the hash (#jumptarget) to the pageurl
				});

				return false;
		});

		$(".nav__exit-trigger,.hamburger").click(function () {
			$(".hamburger").toggleClass("hamburger--active");
			$(".nav__list").toggleClass("nav__list--active");
		});

		if( $( '.slider-list'  ).length ){

			$( '.slider-list' ).slick({
				dots: true,
				infinite: false,
				speed: 300,
				slidesToShow: 1,
				slidesToScroll: 1,
			});

		}


		if( $('.technology-list').length ){

			$( '.technology-list' ).slick( {
				dots: false,
				arrows: true,
				speed: 300,
				infinite: false,
				slidesToShow: 1,
				slidesToScroll: 1,
				appendArrows: $('.technology-box__arrows')
			} )

		}

		if( $('.technology-boxes').length ){ 

			$( '.technology-boxes' ).on( 'click', '.technology-boxes__single', function(){
				const data = parseInt( $(this).data( 'technology' )  ) - 1,
							wrapper = $(this).parents( '.technology-boxes' );

				if( $(this).hasClass('active') ){
					return;
				}

				$( '.technology-boxes__single.active', wrapper ).removeClass('active')
				$(this).addClass('active')
				$('.technology-list').slick('slickGoTo', data);
				
			} )

		}

		$( '.technology-list' ).on('beforeChange', function(event, slick, currentSlide, nextSlide){

			const slide = $( '.technology-list' ).find('.technology-list__single').eq(nextSlide)

			$( '.technology-boxes__single.active' ).removeClass( 'active' )
			$( '.technology-boxes__single[data-technology="'+ slide.data('technology') +'"]' ).addClass('active')


		});

		if( $( '.footer-box__top' ).length ){

			$( '.footer-box__top' ).on( 'click', function(e){
				e.preventDefault();

				$('html,body').animate( { scrollTop: 0 }, 600 );

			} )

		}


	});


	$(window).scroll(function() {
		var scrollDistance = $(window).scrollTop();

		$('.page-section').each(function(i) {

				if ($(this).position().top <= scrollDistance) {
						$('.nav__item.active').removeClass('active');
						$('.nav__item').eq(i).addClass('active');
				}
		});
	}).scroll();

})(jQuery)